import { useState } from "react";
import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Collapse,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { Link } from "react-router-dom";

const MatchesMenuGroup = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <ListItemButton onClick={() => setOpen((v) => !v)}>
        <ListItemIcon>
          <SportsSoccerIcon />
        </ListItemIcon>

        <ListItemText primary="Manage Matches" />
        {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </ListItemButton>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItemButton component={Link} to={"/matches"} sx={{ pl: 4 }}>
            <ListItemText primary="Matches" />
          </ListItemButton>

          <ListItemButton component={Link} to={"/matches/teams"} sx={{ pl: 4 }}>
            <ListItemText primary="Teams" />
          </ListItemButton>

          <ListItemButton
            component={Link}
            to={"/matches/leagues"}
            sx={{ pl: 4 }}
          >
            <ListItemText primary="Leagues" />
          </ListItemButton>

          <ListItemButton
            component={Link}
            to={"/matches/world-cup-nations"}
            sx={{ pl: 4 }}
          >
            <ListItemText primary="World Cup Nations" />
          </ListItemButton>
        </List>
      </Collapse>
    </>
  );
};

export default MatchesMenuGroup;
